import { UtilityPagesApi } from "../../Api";
import { useQuery } from "@tanstack/react-query";
export const useAboutUsPage = ()=>{
    const utilityPages = new UtilityPagesApi();
    const useAboutUsPageQuery = function() {
        let slug = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "about-us";
        return useQuery([
            "utility-pages",
            slug
        ], ()=>utilityPages.getUtilityPage(slug));
    };
    return {
        useAboutUsPageQuery
    };
};
